import { render, staticRenderFns } from "./MandatoryColorModuleFilters.vue?vue&type=template&id=0c8403e0&scoped=true"
import script from "./MandatoryColorModuleFilters.vue?vue&type=script&lang=ts"
export * from "./MandatoryColorModuleFilters.vue?vue&type=script&lang=ts"
import style0 from "./MandatoryColorModuleFilters.vue?vue&type=style&index=0&id=0c8403e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8403e0",
  null
  
)

export default component.exports